<template>
  <div class="ux-popconfirm my-popconfirm">
    <el-popover v-bind="$attrs" v-model="visible" @show="show" @hide="hide">
      <template slot="reference" v-if="$slots.reference">
        <slot name="reference"></slot>
      </template>
      <slot name="title" v-if="$slots.title"></slot>
      <p :style="`display: flex; align-items: flex-start; margin-bottom: 12px; width: ${width}`" v-else>
        <i
          :class="icon"
          :style="{ color: iconColor, fontSize: '16px', marginRight: '5px' }"
          v-if="!hideIcon"
        ></i>
        <span style="font-size:14px,color:#161E28">{{ title }}</span>
      </p>
      <div style="text-align: right; margin: 0">
        <ux-button
          :type="cancelButtonType"
          plain
          size="small"
          style="border: 1px solid #bcc4d4; color: #8690aa; margin-right: 3px"
          @click="onCancel"
          >{{ cancelButtonText }}</ux-button
        >
        <ux-button :type="confirmButtonType" size="small" @click="onConfirm">{{
          confirmButtonText
        }}</ux-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
  name: 'MyPopconfirm',
  model: {
    prop: 'value'
  },
  props: {
    width: {
      type: String,
      default: '150px'
    },
    title: {
      type: String,
      default: ''
    },
    confirmButtonText: {
      type: String,
      default: () => i18n.t('HT.confirm')
    },
    cancelButtonText: {
      type: String,
      default: () => i18n.t('HT.cancel')
    },
    confirmButtonType: {
      type: String,
      default: 'primary'
    },
    cancelButtonType: {
      type: String,
      default: 'primary'
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    iconColor: {
      type: String,
      default: '#f90'
    },
    icon: {
      type: String,
      default: 'ux_icon_tips_alarm'
    }
  },
  data() {
    return {
      visible: this.value
    };
  },
  methods: {
    onCancel() {
      this.visible = false;
      this.$emit('onCancel');
    },
    onConfirm() {
      this.visible = false;
      this.$emit('onConfirm');
    },
    show() {
      this.$emit('show');
    },
    hide() {
      this.$emit('hide');
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.visible = newVal;
      },
      deep: true
    }
  }
};
</script>
